import React, { useState } from 'react';
import { useVideo } from '../../../contexts/VideoContext';
import './Steps.css';

const ACTIVITIES = [
  { value: 'playing', label: 'Playing', emoji: '🎾', description: 'Had fun with toys' },
  { value: 'socializing', label: 'Socializing', emoji: '🐕', description: 'Made new friends' },
  { value: 'training', label: 'Training', emoji: '🎓', description: 'Learned new tricks' },
  { value: 'napping', label: 'Napping', emoji: '😴', description: 'Got some rest' },
  { value: 'eating', label: 'Eating', emoji: '🍖', description: 'Enjoyed treats' },
  { value: 'walking', label: 'Walking', emoji: '🚶', description: 'Went on walks' },
  { value: 'swimming', label: 'Swimming', emoji: '🏊', description: 'Splashed around' },
  { value: 'running', label: 'Running', emoji: '🏃', description: 'Zoomed around' },
  { value: 'cuddling', label: 'Cuddling', emoji: '🤗', description: 'Got pets and hugs' },
  { value: 'exploring', label: 'Exploring', emoji: '🔍', description: 'Sniffed everything' },
];

const Step4Activities = () => {
  const { videoData, updateVideoData, nextStep, prevStep } = useVideo();
  const [selectedActivities, setSelectedActivities] = useState(videoData.activities || []);
  const [error, setError] = useState('');

  const handleActivityToggle = (activity) => {
    setSelectedActivities((prev) => {
      if (prev.includes(activity)) {
        return prev.filter((a) => a !== activity);
      } else {
        if (prev.length >= 2) {
          setError('You can select up to 2 activities');
          return prev;
        }
        setError('');
        return [...prev, activity];
      }
    });
  };

  const handleNext = () => {
    if (selectedActivities.length === 0) {
      setError('Please select at least one activity');
      return;
    }

    updateVideoData({ activities: selectedActivities });
    nextStep();
  };

  return (
    <div className="wizard-step">
      <div className="step-content">
        <div className="step-icon">🎯</div>
        <h2 className="step-title">What Did {videoData.petName} Do Today?</h2>
        <p className="step-description">
          Select up to 2 activities (selected: {selectedActivities.length}/2)
        </p>

        <div className="activity-grid">
          {ACTIVITIES.map((activity) => (
            <button
              key={activity.value}
              type="button"
              className={`activity-card ${
                selectedActivities.includes(activity.value) ? 'selected' : ''
              }`}
              onClick={() => handleActivityToggle(activity.value)}
            >
              <span className="activity-emoji">{activity.emoji}</span>
              <h3 className="activity-label">{activity.label}</h3>
              <p className="activity-description">{activity.description}</p>
              {selectedActivities.includes(activity.value) && (
                <span className="check-icon">✓</span>
              )}
            </button>
          ))}
        </div>

        {error && <div className="error-message">{error}</div>}

        {/* Navigation */}
        <div className="step-navigation">
          <button type="button" className="btn-secondary" onClick={prevStep}>
            <span className="btn-icon">←</span>
            Back
          </button>
          <button type="button" className="btn-primary" onClick={handleNext}>
            Next Step
            <span className="btn-icon">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step4Activities;
